import React from "react"

import { AppRoutes } from "@constants/AppRoutes.ts"
import { useLoggedUserData } from "@hooks/useLoggedUserData.ts"
import { AppLocalStorageKeys } from "@constants/AppLocalStorageKeys.ts"
import { IAuthorizedProfiles } from "@constants/AppAuthorizedProfiles.ts"
import { Navigate, useLocation, useNavigate } from "react-router-dom"

interface IProtectedRouteProps {
	children: React.ReactNode
	authorizedProfiles: IAuthorizedProfiles[]
}

const ProtectedRoute: React.FC<IProtectedRouteProps> = ({
	children,
	authorizedProfiles,
}) => {
	const navigate = useNavigate()
	const location = useLocation()

	const { loggedUser } = useLoggedUserData()

	React.useLayoutEffect(() => {
		if (!loggedUser) return

		if (
			!authorizedProfiles.includes(
				loggedUser?.profileType as IProtectedRouteProps["authorizedProfiles"][0]
			)
		) {
			navigate(AppRoutes.notAuthorized, { replace: true })
		}
	}, [loggedUser, authorizedProfiles])

	const isAuthenticated = !!localStorage.getItem(AppLocalStorageKeys.TOKEN)
	const currentPath = location.pathname + location.search

	if (!isAuthenticated) {
		return <Navigate to={AppRoutes.login} state={{ from: currentPath }} />
	}

	return <>{children}</>
}

export default ProtectedRoute
